import { render, staticRenderFns } from "./orderDel.vue?vue&type=template&id=bb154f8c&scoped=true"
import script from "./orderDel.vue?vue&type=script&lang=js"
export * from "./orderDel.vue?vue&type=script&lang=js"
import style0 from "./orderDel.vue?vue&type=style&index=0&id=bb154f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb154f8c",
  null
  
)

export default component.exports